// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.electrical-stability-report-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 9pt;
}
.electrical-stability-report-table th,
.electrical-stability-report-table td {
  padding: 3px 4px;
  border: 1px solid #20252b;
  vertical-align: middle;
  text-align: center;
}
.electrical-stability-report-table thead th {
  background: #fff;
  color: #20252b;
  font-weight: 700;
}
.electrical-stability-report-table thead tr:first-child th {
  background: #ffffe5;
  font-weight: 400;
}
.electrical-stability-report-table tbody th {
  text-align: left;
}
.electrical-stability-report-table tbody td {
  background: #fff;
}

.empty-state {
  margin: 4px 0;
  color: #69747d;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-request-report/job-request-report-tests/electrical-stability-test-report.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AACF;AACE;;EAEE,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AAEE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,gBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AAJF","sourcesContent":[":host {\n  display: block;\n}\n\n.electrical-stability-report-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 9pt;\n\n  th,\n  td {\n    padding: 3px 4px;\n    border: 1px solid #20252b;\n    vertical-align: middle;\n    text-align: center;\n  }\n\n  thead th {\n    background: #fff;\n    color: #20252b;\n    font-weight: 700;\n  }\n\n  thead tr:first-child th {\n    background: #ffffe5;\n    font-weight: 400;\n  }\n\n  tbody th {\n    text-align: left;\n  }\n\n  tbody td {\n    background: #fff;\n  }\n}\n\n.empty-state {\n  margin: 4px 0;\n  color: #69747d;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
